import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniabusonrentinpunewala() {



    const cardData =
    {
        keyword: 'Urbania Bus on Rent in Punawale',
        heading: 'Urbania on rent in pune: Urbania Bus on Rent in Punawale',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Urbania Bus on Rent in Punawale services for corporate groups, families, tourists, and event travelers seeking comfortable and spacious group transportation. Our well-maintained Force Urbania bus fleet provides generous seating, air-conditioned comfort, ample luggage space, and smooth performance, making it ideal for corporate travel, airport transfers, weddings, sightseeing, local trips, and outstation journeys from Punawale. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from Punawale, Ravet, Wakad, Hinjewadi, Akurdi, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for Urbania bus hire in Punawale.',

        top: 'Top Places to Visit in Pune with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha glory. Known for its massive stone walls, grand gateways like Delhi Darwaza, and lush lawns, it served as the seat of Bajirao I’s administration. Despite being partially destroyed by fire, the remnants echo royal grandeur. Evening light-and-sound shows vividly bring Maratha history to life, making it a must-visit heritage site."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is a historical monument linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with Gandhi’s personal artifacts, photographs, and the samadhis of Kasturba and Mahadev Desai. Its sprawling gardens, Italian arches, and tranquil ambiance make it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The temple trust is known for charitable work. Devotees find immense peace and blessings here, making it the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a rugged hill, Sinhagad Fort is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to explore ancient ramparts, memorials, and scenic viewpoints. Local vendors offer traditional pithla-bhakri meals near the summit. The fort provides panoramic views of the Sahyadri ranges, blending history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase early Indian craftsmanship, making it Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a highlight, making it Pune’s living archive of art, craftsmanship, and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are especially mesmerizing, making Parvati Hill a spiritual and scenic highlight."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and spiritual transformation, making it Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Featuring flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers, it is ideal for families, photography enthusiasts, and peaceful strolls. The garden blends Japanese aesthetics with Indian nature, serving as Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot for locals. The vast waterscape and surrounding hills create picturesque views, especially during monsoon. Street vendors sell roasted corn and tea, adding local flavor. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy weekend escape and sunset viewpoint."
  }
],




"services": [
{
"name": "Urbania Bus on Rent in Punawale",
"description": "Urbania Bus on Rent in Punawale offers reliable and comfortable Urbania bus rental services for local, outstation, and event-based travel. The buses are spacious, well-maintained, and designed to provide a smooth ride for families, corporate teams, and groups. With clean interiors, comfortable seating, and ample luggage space, the service ensures a pleasant travel experience. Professional drivers with good route knowledge ensure safe driving, timely pickups, and stress-free journeys from Punawale to nearby and long-distance destinations."
},
{
"name": "Punawale Urbania Bus Hire",
"description": "Punawale Urbania Bus Hire provides flexible and dependable bus hire solutions for various travel needs including tours, functions, and corporate travel. The Urbania buses are ideal for group travel, offering generous seating space, safety features, and a smooth ride quality. Experienced chauffeurs manage traffic and routes efficiently, ensuring punctuality and comfort. This service is suitable for families, office teams, and travelers looking for hassle-free transportation from Punawale."
},
{
"name": "Urbania Rental Service Punawale Pune",
"description": "Urbania Rental Service Punawale Pune delivers professional Urbania bus rentals with a focus on comfort, safety, and customer satisfaction. The buses are regularly serviced and maintained for reliable performance on both short and long journeys. With options for AC and non-AC buses, this service supports family trips, corporate outings, and group tours. Skilled drivers ensure smooth travel, making it a trusted choice for residents and businesses in Punawale."
},
{
"name": "Urbania AC Bus on Rent Punawale",
"description": "Urbania AC Bus on Rent Punawale offers fully air-conditioned Urbania buses for comfortable travel in all weather conditions. The AC buses provide a relaxed and climate-controlled environment, making long journeys enjoyable for passengers. Clean interiors, comfortable seating, and professional chauffeurs ensure a premium travel experience. This service is ideal for family outings, corporate travel, airport transfers, and outstation trips from Punawale."
},
{
"name": "Corporate Urbania Hire Punawale",
"description": "Corporate Urbania Hire Punawale provides organized and punctual transportation solutions for corporate offices and business groups. The service focuses on professionalism, timely pickups, and comfortable travel for employees and executives. With spacious seating, clean buses, and trained drivers, it is well-suited for corporate meetings, conferences, team outings, and business tours from Punawale to various destinations."
},
{
"name": "Urbania for Outstation Punawale Pune",
"description": "Urbania for Outstation Punawale Pune offers dependable Urbania bus rentals for long-distance and interstate travel. The buses are designed for highway journeys with comfortable seating, ample legroom, and sufficient luggage space. Experienced drivers familiar with outstation routes ensure safe and smooth travel. This service is ideal for family vacations, pilgrimages, corporate tours, and group trips starting from Punawale."
},
{
"name": "Urbania Airport Transfer Punawale",
"description": "Urbania Airport Transfer Punawale provides reliable and timely transportation for airport pickups and drop-offs. The service ensures punctual arrivals, comfortable seating, and ample luggage space for passengers traveling to and from the airport. Professional chauffeurs track schedules and choose efficient routes, making airport travel stress-free for families, corporate travelers, and groups in Punawale."
},
{
"name": "Luxury Urbania Punawale",
"description": "Luxury Urbania Punawale offers premium Urbania buses with refined interiors, plush seating, and enhanced comfort for travelers who prefer a superior travel experience. These buses are ideal for VIP travel, special occasions, weddings, and corporate guests. With professional chauffeurs and well-maintained vehicles, the service delivers elegance, safety, and comfort on every journey."
},
{
"name": "Affordable Urbania Hire Punawale",
"description": "Affordable Urbania Hire Punawale provides cost-effective bus rental solutions without compromising on comfort or safety. The buses are clean, spacious, and reliable, making them suitable for families, students, and group travelers on a budget. Professional drivers ensure punctual and safe journeys, offering excellent value for money for local and outstation travel from Punawale."
},
{
"name": "Chauffeur Driven Urbania Punawale",
"description": "Chauffeur Driven Urbania Punawale ensures a relaxed and worry-free travel experience with trained and verified drivers. The chauffeurs are experienced in handling city and highway routes, ensuring smooth navigation and safe driving. Passengers can enjoy comfortable seating, clean interiors, and reliable service, making it ideal for families, corporate groups, and tourists."
},
{
"name": "Urbania for Wedding Events Punawale",
"description": "Urbania for Wedding Events Punawale offers organized and comfortable transportation for wedding guests and family members. The buses provide spacious seating, clean interiors, and ample luggage space for gifts and belongings. Professional drivers ensure timely pickups and drop-offs across multiple venues, making wedding transportation smooth and well-coordinated."
},
{
"name": "Urbania for Office Trips Punawale",
"description": "Urbania for Office Trips Punawale provides reliable bus services for office outings, team-building activities, and corporate tours. The service ensures comfortable travel with well-maintained buses, professional drivers, and punctual scheduling. It is ideal for companies seeking safe and efficient group transportation from Punawale."
},
{
"name": "Best Urbania Rental Punawale Pune",
"description": "Best Urbania Rental Punawale Pune is known for high-quality vehicles, dependable service, and customer satisfaction. The buses are spacious, clean, and suitable for various travel needs including corporate, family, and group travel. With experienced drivers and flexible rental options, this service is a preferred choice for Urbania rentals in Punawale."
},
{
"name": "Urbania Group Travel Punawale",
"description": "Urbania Group Travel Punawale specializes in transporting large groups comfortably and efficiently. The buses offer ample seating, luggage space, and smooth ride quality, ensuring everyone travels together without inconvenience. This service is ideal for tours, events, corporate groups, and family gatherings starting from Punawale."
},
{
"name": "Reliable Urbania Hire Punawale Pune",
"description": "Reliable Urbania Hire Punawale Pune delivers dependable and safe Urbania bus rental services with a strong focus on punctuality and customer satisfaction. The buses are regularly maintained, and professional drivers ensure smooth journeys for all types of travel. Families, corporate clients, and groups can trust this service for consistent and hassle-free transportation."
}
],
"tableData": [
["Urbania Bus on Rent in Punawale", "Punawale Urbania Bus Hire"],
["Urbania Rental Service Punawale Pune", "Urbania AC Bus on Rent Punawale"],
["Corporate Urbania Hire Punawale", "Urbania for Outstation Punawale Pune"],
["Urbania Airport Transfer Punawale", "Luxury Urbania Punawale"],
["Affordable Urbania Hire Punawale", "Chauffeur Driven Urbania Punawale"],
["Urbania for Wedding Events Punawale", "Urbania for Office Trips Punawale"],
["Best Urbania Rental Punawale Pune", "Urbania Group Travel Punawale"],
["Reliable Urbania Hire Punawale Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Urbania Bus on Rent in Punawale for Comfortable Travel",
        "WhyChoosedescription": "Urbania Bus on Rent in Punawale is perfect for local trips, family outings, group travel, corporate events, and leisure journeys, ensuring a smooth and hassle-free experience."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses in Punawale are equipped with air-conditioning, comfortable reclining seats, ample legroom, and plenty of luggage space for a relaxed journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "All drivers are licensed, trained, and familiar with Punawale city routes and nearby destinations, ensuring safe and stress-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Urbania Bus on Rent in Punawale offers competitive pricing with no hidden charges, making group travel cost-effective and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated support for inquiries, reservations, and last-minute travel plans."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for local sightseeing, family trips, corporate outings, multi-day journeys, and customized travel plans as per your schedule."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and maintained to ensure passenger comfort and hygiene."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Urbania Bus on Rent in Punawale service guarantees on-time pickups, dependable service, and a smooth travel experience."
    }
]
}
const faqData = [
    {
        question: 'Can Urbania Bus on Rent in Punawale be booked for local and group travel?',
        answer: 'Yes, it is ideal for local trips, group outings, family travel, and corporate events in and around Punawale.'
    },
    {
        question: 'How can I book Urbania Bus on Rent in Punawale?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Urbania Bus on Rent in Punawale?',
        answer: 'This service offers spacious seating, professional drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced with Punawale routes?',
        answer: 'Yes, all drivers are licensed, trained, and familiar with Punawale city routes and nearby destinations.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Punawale and surrounding areas.'
    },
    {
        question: 'Is Urbania Bus on Rent in Punawale available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your trip.'
    },
    {
        question: 'Is this service suitable for families and corporate groups?',
        answer: 'Yes, Urbania Bus on Rent in Punawale is ideal for families, corporate groups, tourists, and large travel parties.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohan Deshmukh',
        feedback: 'We rented an Urbania bus in Punawale for a family outing. The service was punctual, the bus was comfortable, and the journey was enjoyable.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Shraddha Kulkarni',
        feedback: 'Professional service with a friendly driver. Urbania Bus on Rent in Punawale made our group travel easy and enjoyable.',
        rating: 5
    }
];
















































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Bus on Rent in Punawale",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-punawale.jpg",
  "description": "Urbania Bus on Rent in Punawale offers AC Urbania buses for one-way or round-trip travel, corporate trips, airport transfers, weddings, office trips, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation in and around Punawale, Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-bus-on-rent-in-punawale"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Bus on Rent in Punawale | AC Urbania Bus for Corporate, Weddings & Outstation 
  </title>

  <meta
    name="description"
    content="Book Urbania Bus on Rent in Punawale for one-way or round-trip travel, corporate trips, airport transfers, weddings, office trips, and group travel. AC chauffeur-driven Urbania buses provide safe, comfortable, and convenient transportation in and around Punawale, Pune."
  />

  <meta
    name="keywords"
    content="Urbania Bus on Rent in Punawale, Punawale Urbania Bus Hire, Urbania Rental Service Punawale Pune, Urbania AC Bus on Rent Punawale, Corporate Urbania Hire Punawale, Urbania for Outstation Punawale Pune, Urbania Airport Transfer Punawale, Luxury Urbania Punawale, Affordable Urbania Hire Punawale, Chauffeur Driven Urbania Punawale, Urbania for Wedding Events Punawale, Urbania for Office Trips Punawale, Best Urbania Rental Punawale Pune, Urbania Group Travel Punawale, Reliable Urbania Hire Punawale Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/112.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniabusonrentinpunewala;